var render = function render(){var _vm=this,_c=_vm._self._c;return _c('permissions-table',{attrs:{"headers":_vm.headers,"permissions":_vm.permissions},on:{"deletePermission":function($event){return _vm.deletePermission($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }